import React, {Component} from 'react';
import moment from 'moment';
import Slider from 'react-slick';
import { withTranslation } from "react-i18next";

class ParagraphGuestBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showHiddenPages: false,
      sliderSettings: {
        dots: true,
        arrows: false,
        adaptiveHeight: true,
        rows: 3,
        slidesPerRow: 3,
        customPaging: function(i) {
          return (
            <a href="">{i+1}</a>
          );
        },
        appendDots: (dots) => {
          const visiblePages = dots.slice(0, 5);
          const hiddenPages = dots.slice(5, dots.length);
          const hiddenPagesClass = this.state.showHiddenPages ? 'd-block' : 'd-none';

          return (
            <>
              <ul className={'slick-dots'}>
                {visiblePages}
                <span style={{cursor: 'pointer'}} onClick={this.toggleHiddenPages}>...</span>
              </ul>
              <ul className={`slick-dots ${hiddenPagesClass}`} data-hidden-pages={props.id}>{hiddenPages}</ul>
            </>
          );
        },
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              rows: 5,
              slidesPerRow: 1,
            }
          }
        ]
      }
    }
  }

  toggleHiddenPages = () => {
    this.setState({
      showHiddenPages: !this.state.showHiddenPages
    });
  }

  render() {
    return (
      <>
        <div className="container">
          <div className="row">
            <section className="paragraph-guest-book-section">
              {this.props.content.entities.length !== 0 &&
                <Slider {...this.state.sliderSettings}>
                  {this.props.content.entities.map((item, index) =>
                    <div key={index} className="paragraph-guest-book-entry col-sm-12 col-lg-4">
                      <div className="guestbook-header">
                      <span>
                        {moment.unix(item.created).format('DD.MM.YYYY')}&nbsp;
                        <strong>{item.title}</strong>
                      </span>
                      </div>
                      <div className="guestbook-content">
                        {item.fieldGuestbookEntry !== null &&
                          <div dangerouslySetInnerHTML={{ __html: item.fieldGuestbookEntry }} />
                        }
                      </div>
                      <div className="guestbook-comment">
                        {item.fieldKommentare.length !== 0 &&
                          <div className="paragraph paragraph--type--comment paragraph--view-mode--default">
                            {item.fieldKommentare.map(( comment, cndex ) =>
                              <div key={cndex}>
                                <div>Kommentar:</div>
                                <p dangerouslySetInnerHTML={{ __html: comment.entity.fieldKommentar.value }}/>
                              </div>
                            )}
                          </div>
                        }
                      </div>
                    </div>
                  )}
                </Slider>
              }
            </section>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(ParagraphGuestBook);
